import React from "react";
import { motion } from "framer-motion";

export default function Apropos() {
  // Animation parent (effet cascade lente)
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.35 },
    },
  };

  // Animation douce pour chaque élément
  const fadeItem = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      id="apropos"
      className="py-20 bg-white flex flex-col md:flex-row items-center justify-center px-6 md:px-16"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      {/* Image à gauche */}
      <motion.div
        className="md:w-1/2 mb-10 md:mb-0"
        variants={fadeItem}
      >
        <img
          src="https://images.unsplash.com/photo-1521791055366-0d553872125f?auto=format&fit=crop&w=800&q=80"
          alt="Équipe Virtuo Systems Maroc"
          className="rounded-2xl shadow-lg w-full h-auto"
        />
      </motion.div>

      {/* Texte à droite */}
      <motion.div
        className="md:w-1/2 md:pl-12 text-center md:text-left"
        variants={fadeItem}
      >
        <h2 className="text-4xl font-bold text-primary mb-6">
          À propos de nous
        </h2>

        <p className="text-gray-700 mb-4 leading-relaxed">
          <strong>Virtuo Systems Maroc</strong> est une société marocaine
          spécialisée dans la conception, l’intégration et la maintenance de
          solutions informatiques et réseaux pour les entreprises.
        </p>

        <p className="text-gray-700 mb-4 leading-relaxed">
          Nous accompagnons nos clients dans leur transformation digitale à
          travers des services fiables et innovants couvrant la sécurité
          informatique, le déploiement réseau, la téléphonie IP et le
          développement d’applications web.
        </p>

        <p className="text-gray-700 mb-6 leading-relaxed">
          Notre mission est de garantir la performance, la disponibilité et la
          sécurité de votre infrastructure IT tout en vous aidant à innover.
        </p>

        {/* Valeurs avec apparition progressive */}
        <motion.div
          className="flex flex-wrap justify-center md:justify-start gap-4"
          variants={container}
        >
          <motion.span
            className="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium"
            variants={fadeItem}
          >
            Innovation
          </motion.span>
          <motion.span
            className="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium"
            variants={fadeItem}
          >
            Fiabilité
          </motion.span>
          <motion.span
            className="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium"
            variants={fadeItem}
          >
            Performance
          </motion.span>
        </motion.div>
      </motion.div>
    </motion.section>
  );
}
